import { CornerstoneTools } from './cornerstoneToolsDict';

export interface ExpandableTool {
  show: boolean,
  selectedIndex: number,
  defaultIndex: number,
  name: string,
  tools:
  {
    index: number,
    disabled: boolean,
    name: string,
    tool: any,
    icon: string,
    color: string,
    func: string,
    args: any[]
  }[]
};

export const WindowingTools: ExpandableTool = {
  show: false,
  selectedIndex: 1,
  defaultIndex: 1,
  name: 'Windowing',
  tools: [
    {
      index: 0,
      name: 'Invertir',
      tool: '',
      icon: 'visor-icons icon-invert',
      color: 'golden',
      func: 'invertImage',
      args: [],
      disabled: false,
    },
    {
      index: 1,
      name: 'Windowing',
      tool: CornerstoneTools.Wwwc,
      icon: 'visor-icons icon-ww',
      color: 'golden',
      func: 'enableTool',
      args: [1, 'Wwwc'],
      disabled: false,
    },
    {
      index: 2,
      name: 'Región de Windowing',
      tool: CornerstoneTools.WwwcRegion,
      icon: 'visor-icons icon-ww_zone',
      color: 'golden',
      func: 'enableTool',
      args: [1, 'WwwcRegion'],
      disabled: true,
    },
    {
      index: 3,
      name: 'Sincronizar Windowing',
      tool: '',
      icon: 'visor-icons icon-synch_ww',
      color: 'golden',
      func: 'toggleSynchronize',
      args: ['Wwwc'],
      disabled: true,
    },
  ]
}

export const RotationTools: ExpandableTool = {
  show: false,
  selectedIndex: 4,
  defaultIndex: 4,
  name: 'Rotación',
  tools: [
    {
      index: 0,
      name: 'Reflejo Vertical',
      tool: '',
      icon: 'visor-icons icon-flip_vertical',
      color: 'green',
      func: 'flipImage',
      args: ['v'],
      disabled: false,
    },
    {
      index: 1,
      name: 'Reflejo Horzontal',
      tool: '',
      icon: 'visor-icons icon-flip_horizontal',
      color: 'green',
      func: 'flipImage',
      args: ['h'],
      disabled: false,
    },
    {
      index: 2,
      name: 'Rotar -90º',
      tool: '',
      icon: 'visor-icons icon-rotate_left',
      color: 'green',
      func: 'rotate',
      args: [-90],
      disabled: false,
    },
    {
      index: 3,
      name: 'Rotar 90º',
      tool: '',
      icon: 'visor-icons icon-rotate_right',
      color: 'green',
      func: 'rotate',
      args: [90],
      disabled: false,
    },
    {
      index: 4,
      name: 'Rotación Libre',
      tool: CornerstoneTools.Rotate,
      icon: 'visor-icons icon-rotate',
      color: 'green',
      func: 'enableTool',
      args: [1, 'Rotate'],
      disabled: false,
    },
    // {
    //   index: 5,
    //   name: 'Restaurar',
    //   tool: '',
    //   icon: 'visor-icons icon-reset',
    //   color: 'green',
    //   func: 'resetImage',
    //   args: [],
    //   disabled: false,
    // },
    {
      index: 5,
      name: 'Restaurar',
      tool: '',
      icon: 'visor-icons icon-reset',
      color: 'green',
      func: 'resetImage',
      args: [],
      disabled: false,
    },
  ]
}

export const PanZoomTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Mover / Zoom',
  tools: [
    {
      index: 0,
      name: 'Mover',
      tool: CornerstoneTools.Pan,
      icon: 'visor-icons icon-pan',
      color: 'blue',
      func: 'enableTool',
      args: [1, 'Pan'],
      disabled: false,
    },
    {
      index: 1,
      name: 'Zoom',
      tool: CornerstoneTools.Zoom,
      icon: 'visor-icons icon-zoom',
      color: 'blue',
      func: 'enableTool',
      args: [1, 'Zoom'],
      disabled: false,
    },
    {
      index: 2,
      name: 'Lente',
      tool: CornerstoneTools.Magnify,
      icon: 'visor-icons icon-magnify',
      color: 'blue',
      func: 'enableTool',
      args: [1, 'Magnify'],
      disabled: false,
    },
    {
      index: 3,
      name: 'Sincronizar Mover/Zoom',
      tool: '',
      icon: 'visor-icons icon-synch_zoom',
      color: 'blue',
      func: 'toggleSynchronize',
      args: ['PanZoom'],
      disabled: true,
    },
  ]
}

export const ROITools: ExpandableTool = {
  show: false,
  selectedIndex: 1,
  defaultIndex: 1,
  name: 'Anotaciones',
  tools: [
    {
      index: 0,
      name: 'Píxel',
      tool: CornerstoneTools.Probe,
      icon: 'visor-icons icon-probe',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Probe'],
      disabled: false,
    },
    {
      index: 1,
      name: 'Distancia',
      tool: CornerstoneTools.Length,
      icon: 'visor-icons icon-length',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Length'],
      disabled: false,
    },
    {
      index: 2,
      name: 'Rectángulo',
      tool: CornerstoneTools.RectangleRoi,
      icon: 'visor-icons icon-rectangle',
      color: 'red',
      func: 'enableTool',
      args: [1, 'RectangleRoi'],
      disabled: false,
    },
    {
      index: 3,
      name: 'Polígono',
      tool: CornerstoneTools.FreehandRoi,
      icon: 'visor-icons icon-polygon_measure',
      color: 'red',
      func: 'enableTool',
      args: [1, 'FreehandRoi'],
      disabled: false,
    },
    {
      index: 4,
      name: 'Elipse',
      tool: CornerstoneTools.EllipticalRoi,
      icon: 'visor-icons icon-ellipse_measure',
      color: 'red',
      func: 'enableTool',
      args: [1, 'EllipticalRoi'],
      disabled: false,
    },
    {
      index: 5,
      name: 'Ángulo',
      tool: CornerstoneTools.Angle,
      icon: 'visor-icons icon-angle',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Angle'],
      disabled: false,
    },
    {
      index: 6,
      name: 'Ángulo de Cobb',
      tool: CornerstoneTools.CobbAngle,
      icon: 'visor-icons icon-cobb_angle',
      color: 'red',
      func: 'enableTool',
      args: [1, 'CobbAngle'],
      disabled: false,
    },
    {
      index: 7,
      name: 'Paralelas',
      tool: CornerstoneTools.Parallel,
      icon: 'visor-icons icon-parallel',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Parallel'],
      disabled: false,
    },
    {
      index: 8,
      name: 'Perpendiculares',
      tool: CornerstoneTools.Bidirectional,
      icon: 'visor-icons icon-perpendicular',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Bidirectional'],
      disabled: false,
    },
    {
      index: 9,
      name: 'Línea Horizontal',
      tool: CornerstoneTools.HLine,
      icon: 'visor-icons icon-horizontal_line',
      color: 'red',
      func: 'enableTool',
      args: [1, 'HLine'],
      disabled: false,
    },
    {
      index: 10,
      name: 'Línea Vertical',
      tool: CornerstoneTools.VLine,
      icon: 'visor-icons icon-vertical_line',
      color: 'red',
      func: 'enableTool',
      args: [1, 'VLine'],
      disabled: false,
    },
    {
      index: 11,
      name: 'Flecha con Texto',
      tool: CornerstoneTools.ArrowAnnotate,
      icon: 'visor-icons icon-arrow_text',
      color: 'red',
      func: 'enableTool',
      args: [1, 'ArrowAnnotate'],
      disabled: false,
    },
    {
      index: 12,
      name: 'Texto',
      tool: CornerstoneTools.TextAnnotate,
      icon: 'visor-icons icon-text',
      color: 'red',
      func: 'enableTool',
      args: [1, 'TextAnnotate'],
      disabled: false,
    },
    {
      index: 13,
      name: 'Borrador',
      tool: CornerstoneTools.Eraser,
      icon: 'visor-icons icon-eraser',
      color: 'red',
      func: 'enableTool',
      args: [1, 'Eraser'],
      disabled: false,
    },
  ]
}

export const DrawingTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Dibujo',
  tools: [
    {
      index: 0,
      name: 'Pincel',
      tool: CornerstoneTools.Brush,
      icon: 'visor-icons icon-brush',
      color: 'purple',
      func: 'enableTool',
      args: [1, 'Brush'],
      disabled: true,
    },
    {
      index: 1,
      name: 'Línea',
      tool: CornerstoneTools.LineDraw,
      icon: 'visor-icons icon-minus',
      color: 'purple',
      func: 'enableTool',
      args: [1, 'LineDraw'],
      disabled: true,
    },
    // {
    //   index: 2,
    //   name: 'Polígono',
    //   tool: CornerstoneTools.FreehandDraw,
    //   icon: 'visor-icons icon-polygon_draw',
    //   color: 'purple',
    //   func: 'enableTool',
    //   args: [1, 'FreehandDraw'],
    //   disabled: true,
    // },
    {
      index: 3,
      name: 'Elipse',
      tool: CornerstoneTools.EllipticalDraw,
      icon: 'visor-icons icon-ellipse_draw',
      color: 'purple',
      func: 'enableTool',
      args: [1, 'EllipticalDraw'],
      disabled: true,
    },
  ]
}

export const InjuryTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Lesiones',
  tools: [
    {
      index: 0,
      name: 'Segmentación de lesiones',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Seguimiento de lesiones',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 2,
      name: 'Unión de lesiones',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 3,
      name: 'Corregir segmentación',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    }
  ]
}

export const CardioTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Cardiología',
  tools: [
    {
      index: 0,
      name: 'Análisis Coronario QCA',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Análisis Ventricular LVA',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    }
  ]
}

export const MammoTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Mamografía',
  tools: [
    {
      index: 0,
      name: 'Aplicar máscara de tejido mamario',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Alineación de pezones',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 2,
      name: 'Selección de pezones',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 3,
      name: 'Óvalo',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
  ]
}

export const NeuroTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Neurología',
  tools: [
    {
      index: 0,
      name: 'Test',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Test',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 2,
      name: 'Test',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 3,
      name: 'Test',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
  ]
}

export const VesselsTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Vasos',
  tools: [
    {
      index: 0,
      name: 'Segmentación de vasos',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Corrección de vasos',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 2,
      name: 'Extracción de estructura vascular',
      tool: CornerstoneTools.Placeholder,
      icon: 'material-icons',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    }
  ]
}

export const SpineTools: ExpandableTool = {
  show: false,
  selectedIndex: 0,
  defaultIndex: 0,
  name: 'Columna',
  tools: [
    {
      index: 0,
      name: 'Etiquetar Vértebras',
      tool: CornerstoneTools.Placeholder,
      icon: 'visor-icons visor-icons-sp icon-spine-tag',
      color: 'silver',
      func: '',
      args: [],
      disabled: true,
    },
    {
      index: 1,
      name: 'Ángulo de Cobb',
      tool: CornerstoneTools.CobbAngle,
      icon: 'visor-icons icon-cobb_angle',
      color: 'silver',
      func: 'enableTool',
      args: [1, 'CobbAngle'],
      disabled: false,
    },
  ]
}